import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=9c4951fc&scoped=true&"
import script from "./UserSelect.vue?vue&type=script&lang=js&"
export * from "./UserSelect.vue?vue&type=script&lang=js&"
import style0 from "./UserSelect.vue?vue&type=style&index=0&id=9c4951fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4951fc",
  null
  
)

/* custom blocks */
import block0 from "./UserSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports